import { useCallback, useRef, useState, Suspense } from "react"

import { DropDownMenu, DropDownMenuLoading } from "web/components/DropDownMenu"

export default function useDropDownMenu({
  triggerElementId,
  forceAnchorRight,
  disableFullScreenMobile,
}) {
  const menuClosing = useRef(false)
  const [menuVisible, setMenuVisible] = useState(false)

  const toggleMenu = (e) => {
    if (e) {
      e.stopPropagation()
    }

    if (!menuClosing.current) {
      setMenuVisible(!menuVisible)
    }
  }

  const DropDownMenuFn = useCallback(
    ({ children, transition }) => {
      return (
        <DropDownMenu
          triggerElementId={triggerElementId}
          onClose={() => setMenuVisible(false)}
          transition={transition}
          forceAnchorRight={forceAnchorRight}
          disableFullScreenMobile={disableFullScreenMobile}
        >
          <Suspense fallback={<DropDownMenuLoading />}>{children}</Suspense>
        </DropDownMenu>
      )
    },
    [disableFullScreenMobile, forceAnchorRight, triggerElementId]
  )

  return {
    DropDownMenu: DropDownMenuFn,
    toggleMenu,
    menuVisible,
  }
}
